import { compose, branch, renderComponent } from 'recompose'
import { createStructuredSelector } from 'reselect'

import { addRateToWaitList } from 'subscription-flow/canada/actions'
import { loadOnMount } from 'shared/hoc'

import useRequestPending from 'shared/hooks/useRequestPending'
import { userSelector } from 'auth/selectors'

import { CardSection } from '@components/CardSection'
import LoginSignUpContainer from '@components/LoginSignUpContainer'
import Button from '@components/Button'
import ErrorMessage from '@components/ErrorMessage'

import { addRateToWaitListPendingSelector } from 'subscription-flow/canada/selectors'
import purchaseStyles from 'subscription-flow/styles.module.scss'

const $WaitListInfo = ({ pending, user, goToProducts }) => {
    const { isLoading, error } = useRequestPending(pending)

    if (error) {
        return <ErrorMessage messages={[error]} />
    }

    return (
        <CardSection className={purchaseStyles.contentSection} loading={isLoading}>
            <h5 className="text-uppercase font-weight-bold mb-4">
                <T>subscription.purchase.waitlistinfo.title</T>
            </h5>
            <p className="mb-6">
                <T values={{ email: user.email }}>subscription.purchase.waitlistinfo.feedback</T>
            </p>
            <div className="d-flex justify-content-end">
                <Button btnStyle="outline" href="/dashboard/subscriptions/waitinglist">
                    <T>subscription.purchase.waitlistinfo.mylist</T>
                </Button>
                <Button onClick={goToProducts}>
                    <T>subscription.purchase.waitlistinfo.addproduct</T>
                </Button>
            </div>
        </CardSection>
    )
}

const $WaitListInfoWithLoadOnMount = loadOnMount('addRateToWaitList', ({ item: { rateId, waitListId, startDate } }) => [
    rateId,
    waitListId,
    startDate,
])($WaitListInfo)

const WaitListInfo = compose(
    connect(createStructuredSelector({ user: userSelector, pending: addRateToWaitListPendingSelector }), {
        addRateToWaitList,
    }),
    branch(({ user }) => !user, renderComponent(LoginSignUpContainer), renderComponent($WaitListInfoWithLoadOnMount))
)(WaitListInfo)

export default WaitListInfo
